<template>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="name">Nama Sub Kategori </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="name">Kategori </label>
                <input type="text" v-model="model.parent" class="form-control" readonly>
            </div>
        </div>
        
        <div class="col-md-12">
            <div class="form-group">
                <label for="description">Deskripsi </label>
                <input type="text" v-model="model.description" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    components: {},
    props: {
        detail: {
            type: Object,
            default: () => ({
                name: '',
                icon: '',
                description: '',
                parent_id: null,
                parent: null,
                id: '',
            })
        }, 
        parentCategories: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            model: {
                name: this.detail?.name,
                id: this.detail?.id,
                description: this.detail?.description,
                icon: this.detail?.icon,
                parent_id: this.detail?.parent_id,
                parent: this.detail?.parent?.name || null,
            }
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', id: '', }
        }
    },
    watch: {
        detail: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.model = {
                    name: newVal?.name || '',
                    id: newVal?.id || '',
                    description: newVal?.description || '',
                    icon: newVal?.icon || '',
                    parent_id: newVal?.parent_id || null,
                    parent: newVal?.parent?.name || null,
                }
            }
        }
    }
}
</script>